import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "custom-font-text" }
const _hoisted_2 = { class: "price__hide" }
const _hoisted_3 = ["innerHTML"]

import getters from '@/profile-creation-wizard/store/creation/getters';
    import mutations from '@/profile-creation-wizard/store/creation/mutations';
    import BottomSheetDisplayer from '@/common/ui/BottomSheetDisplayer';
    import {useStore} from 'vuex';
    import {ref, onMounted, computed} from 'vue';
    import {useTranslation} from '@malt/vue3-use';
    import PriceSelection from '@/profile-creation-wizard/components/for-creation/ui/dailyRate/PriceSelection.vue';
    import {useRoute} from 'vue-router';

    const dataHeapTooltipID = 'profile-creation-tooltip-price';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'PriceSelectionFreelancer',
  setup(__props) {

    const store = useStore();
    const {msg} = useTranslation();
    const creationForm = ref(store.getters[getters.creationForm]);

    const priceSelection = ref(null);
    const bottomSheetDisplayer = ref<BottomSheetDisplayer>(null);

    const priceHidden = computed(() => creationForm.value.priceHide);

    onMounted(async () => {
        bottomSheetDisplayer.value = new BottomSheetDisplayer(
            '#details-price-bottom-sheet',
            dataHeapTooltipID,
            priceSelection.value,
            'div.profile-creation-wizard',
        );
    });

    function openBottomSheet(): void {
        bottomSheetDisplayer.value.openBottomSheet();
    }

    function togglePriceHide(e: any): void {
        store.commit(mutations.selectPriceHide, e.target.checked);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_checkbox = _resolveComponent("joy-checkbox")!
  const _component_joy_highlight = _resolveComponent("joy-highlight")!

  return (_openBlock(), _createElementBlock("div", {
    ref_key: "priceSelection",
    ref: priceSelection
  }, [
    _createElementVNode("h2", null, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.v2.details.price.title')), 1),
    _createElementVNode("p", _hoisted_1, [
      _createTextVNode(_toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.price.freelancer.subtitle')) + " ", 1),
      _createElementVNode("a", {
        class: "open-bottom-sheet",
        "data-heap": dataHeapTooltipID,
        onClick: openBottomSheet
      }, _toDisplayString(_unref(msg)('profile.creation.completion.wizard.details.price.help')), 1)
    ]),
    _createVNode(PriceSelection),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_joy_checkbox, {
        checked: priceHidden.value,
        onValueChange: togglePriceHide
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(msg)('profile.section.header.numeral.hide.price.label')), 1)
        ]),
        _: 1
      }, 8, ["checked"]),
      _createVNode(_component_joy_highlight, {
        name: "highlight-hide-price",
        level: "info",
        "display-icon": ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _unref(msg)('profile.section.header.numeral.hide.price.information.text.v2')
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      })
    ])
  ], 512))
}
}

})